<template v-if="test_task.id">
  <info-header-card :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import TestTaskModel from "@/models/lab/TestTaskModel";

export default {
  name: "TestTaskCard",
  components: {
    InfoHeaderCard
  },
  props: {
    test_task: {
      type: Object,
      default: () => new TestTaskModel()
    }
  },
  computed: {
    header() {
      return this.test_task.name;
    },
    rows() {
      return [
        {
          label: "Description",
          value: this.test_task.description
        }
      ];
    }
  }
};
</script>
